import { Observable } from 'rxjs';
import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { AppConfigurationDto } from '@cradua/data';

@Component({
  selector: 'cradua-app-configuration',
  templateUrl: './app-configuration.component.html',
  styleUrls: ['./app-configuration.component.scss'],
})
export class AppConfigurationComponent implements OnChanges {
  appconfigurationForm: FormGroup;
  appconfigurationFormArray: FormGroup;
  control = new FormControl();
  typesInput: string[] = ['MyMap', 'DynamicMap'];
  @Input() appconfigurations: AppConfigurationDto[];
  @Input() routeAnimationsElements: any;
  @Output() appconfiguration = new EventEmitter<AppConfigurationDto[]>();
  @Output() deleteAppConfigurationEvent = new EventEmitter<any>();

  selectedAppConfiguration: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createAppConfigurationForm();
  }

  createAppConfigurationForm() {
    this.appconfigurationForm = this.fb.group({
      type: [this.typesInput[0]],
      leftvalue: ['', Validators.required],
      rightvalue: [''],
      id: null,
    });
    this.appconfigurationFormArray = this.fb.group({
      AppConfigurations: this.fb.array([]),
    });
    this.setAppConfiguration();
  }

  // method to display appconfigurations
  setAppConfiguration() {
    const control = this.appconfigurationFormArray.controls
      .AppConfigurations as FormArray;
    this.appconfigurations.forEach((e) => {
      control.push(
        this.fb.group({
          type: e.type,
          leftvalue: e.leftvalue,
          rightvalue: e.rightvalue,
          id: e.id,
        })
      );
    });
  }

  // method to add AppConfiguration
  addAppConfiguration(value: AppConfigurationDto) {
    const control = this.appconfigurationFormArray.controls
      .AppConfigurations as FormArray;
    control.insert(
      0,
      this.fb.group({
        type: value.type,
        leftvalue: value.leftvalue,
        rightvalue: value.rightvalue,
        id: null,
      })
    );
  }

  selectAppConfiguration(value) {}

  // method to delete appconfiguration from arrary list
  deleteAppConfiguration(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.appconfigurationFormArray.controls
          .AppConfigurations as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.appconfigurations.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.appconfigurations[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: AppConfigurationDto) {
    if (this.appconfigurationForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.appconfigurationFormArray
        .get('AppConfigurations')
        ['controls'][this.selectedIndex].patchValue({
          ...formValue,
        });
    } else {
      this.addAppConfiguration(formValue);
    }
    this.selectedIndex = null;
    this.appconfigurationForm.reset();
  }

  onEdit(index, value: AppConfigurationDto) {
    this.selectedIndex = index;
    this.appconfigurationForm.patchValue({ ...value });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.appconfigurationForm.reset();
  }

  onSubmit(formValue: AppConfigurationDto[]) {
    this.appconfiguration.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteAppConfigurationEvent.emit(this.filteredDelete);
    }
  }
}
